<div class="wrap">
  <div class="table-container">
    <app-ir-rejected-table
      [projectData]="irRejected"
      [loader]="loader"
      [isLabSupervisor]="isLabSupervisor"
      (reloadDataEmitter)="getIrRejected()"
    ></app-ir-rejected-table>
  </div>
</div>